"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPartialLaw = exports.fetchAllXMLZip = exports.fetchLawData = exports.ElawsLawData = exports.fetchLawNameList = exports.LawNameListInfo = exports.fetchElaws = exports.allXMLZipURL = exports.articlesURL = exports.lawdataURL = exports.lawlistsURL = void 0;
const path_1 = __importDefault(require("path"));
const common_1 = require("./data/loaders/common");
const util_1 = require("./util");
const node_fetch_1 = require("./util/node-fetch");
const zip_1 = require("./util/zip");
const fetch = (global["fetch"]) || (global["window"] && window.fetch) || node_fetch_1.fetch;
// eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-member-access
const DOMParser = (global["window"] && window.DOMParser) || require("@xmldom/xmldom").DOMParser;
// eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-member-access
const XMLSerializer = (global["window"] && window.XMLSerializer) || require("@xmldom/xmldom").XMLSerializer;
const domParser = new DOMParser();
const xmlSerializer = new XMLSerializer();
// eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-member-access
// const Blob: typeof window.Blob = (global["window"] && window.Blob) || require("buffer").Blob;
exports.lawlistsURL = "https://laws.e-gov.go.jp/api/1/lawlists/1";
exports.lawdataURL = "https://laws.e-gov.go.jp/api/1/lawdata/";
exports.articlesURL = "https://laws.e-gov.go.jp/api/1/articles/";
exports.allXMLZipURL = "https://laws.e-gov.go.jp/download?file_section=1&only_xml_flag=true";
const fetchElaws = async (url, retry = 5) => {
    if (retry <= 0) {
        throw Error("fetchElaws(): Failed after retries");
    }
    let text;
    try {
        const response = await fetch(url, {
            mode: "cors",
        });
        if (!response.ok)
            throw Error(response.statusText);
        text = await response.text();
    }
    catch (e) {
        console.error(e);
        console.error("request URL: " + url);
        console.error(`remaining retries: ${retry - 1}`);
        return (0, exports.fetchElaws)(url, retry - 1);
    }
    const doc = domParser.parseFromString(text, "text/xml");
    const elResult = doc.getElementsByTagName("DataRoot").item(0)?.getElementsByTagName("Result").item(0);
    const elCode = elResult?.getElementsByTagName("Code").item(0);
    if (!elCode) {
        console.log("request URL: " + url);
        console.log(`remaining retries: ${retry - 1}`);
        await new Promise(r => setTimeout(r, 1000));
        return await (0, exports.fetchElaws)(url, retry - 1);
    }
    if (elCode.textContent !== "0") {
        const msg = elResult?.getElementsByTagName("Message").item(0)?.textContent;
        console.log("request URL: " + url);
        throw Error(msg ?? "fetchElaws(): Unknown Error in XML\nrequest URL");
    }
    const ret = doc.getElementsByTagName("DataRoot").item(0)?.getElementsByTagName("ApplData").item(0);
    if (!ret) {
        console.log("request URL: " + url);
        throw Error("fetchElaws(): ApplData element not exist");
    }
    return ret;
};
exports.fetchElaws = fetchElaws;
class LawNameListInfo {
    LawId;
    LawName;
    LawNo;
    PromulgationDate;
    constructor(LawId, LawName, LawNo, PromulgationDate) {
        this.LawId = LawId;
        this.LawName = LawName;
        this.LawNo = LawNo;
        this.PromulgationDate = PromulgationDate;
    }
}
exports.LawNameListInfo = LawNameListInfo;
const fetchLawNameList = async () => {
    const elApplData = await (0, exports.fetchElaws)(exports.lawlistsURL);
    const lawNameList = [];
    for (const el of Array.from(elApplData.getElementsByTagName("LawNameListInfo"))) {
        lawNameList.push(new LawNameListInfo(el.getElementsByTagName("LawId").item(0)?.textContent ?? "", el.getElementsByTagName("LawName").item(0)?.textContent ?? "", el.getElementsByTagName("LawNo").item(0)?.textContent ?? "", el.getElementsByTagName("PromulgationDate").item(0)?.textContent ?? ""));
    }
    return lawNameList;
};
exports.fetchLawNameList = fetchLawNameList;
class ElawsLawData extends common_1.LawXMLStruct {
    lawID;
    law;
    imageData;
    _xml;
    constructor(lawID, law, imageData, _xml = null) {
        super();
        this.lawID = lawID;
        this.law = law;
        this.imageData = imageData;
        this._xml = _xml;
    }
    // private blobURLs: string[] = [];
    // public override clean() {
    // console.log(`Revoking ${this.blobURLs.length} blob URLs`);
    // while (this.blobURLs.length > 0) {
    //     const url = this.blobURLs.pop();
    //     if (url) URL.revokeObjectURL(url);
    // }
    // }
    _pict = null;
    getXml() {
        const doc = this.law.ownerDocument.implementation.createDocument("", "", null);
        doc.appendChild(doc.createProcessingInstruction("xml", "version=\"1.0\" encoding=\"UTF-8\""));
        doc.appendChild(this.law);
        return xmlSerializer.serializeToString(doc);
    }
    get xml() {
        this._xml = this._xml === null ? this.getXml() : this._xml;
        return this._xml;
    }
    async getPictFileOrBlobURL(src) {
        const _buf = await this.getPictBlob(src);
        if (!_buf)
            return null;
        const { buf, type } = _buf;
        const url = `data:${type};base64,${btoa(new Uint8Array(buf).reduce((s, c) => s + String.fromCharCode(c), ""))}`;
        // this.blobURLs.push(url);
        return { url, type };
    }
    async ensurePict() {
        if (!this.imageData)
            return null;
        if (!this._pict) {
            this._pict = new Map();
            const zipData = await (0, zip_1.unzip)(this.imageData);
            for (const relPath in zipData) {
                const uint8Data = zipData[relPath];
                const buf = uint8Data.buffer.slice(uint8Data.byteOffset, uint8Data.byteOffset + uint8Data.byteLength);
                const ext = path_1.default.extname(relPath);
                const type = ext in util_1.pictMimeDict ? util_1.pictMimeDict[ext] : "application/octet-stream";
                // const blob = new Blob([buf], { type });
                this._pict.set(`./pict/${relPath}`, { buf, type });
            }
        }
        return this._pict;
    }
    async getPictBlob(src) {
        return (await this.ensurePict())?.get(src) ?? null;
    }
}
exports.ElawsLawData = ElawsLawData;
const fetchLawData = async (lawIDOrLawNum) => {
    const elApplData = await (0, exports.fetchElaws)(exports.lawdataURL + lawIDOrLawNum);
    if (!elApplData) {
        throw Error("fetchLawData(): fetchElaws failed");
    }
    const law = elApplData.getElementsByTagName("LawFullText").item(0)?.getElementsByTagName("Law").item(0);
    if (!law) {
        throw Error("fetchLawData(): Law element not exist");
    }
    const elImageData = elApplData.getElementsByTagName("ImageData").item(0);
    const imageData = (elImageData && elImageData.textContent) ? (0, util_1.decodeBase64)(elImageData.textContent) : null;
    return new ElawsLawData(elApplData.getElementsByTagName("LawId").item(0)?.textContent ?? "", law, imageData);
};
exports.fetchLawData = fetchLawData;
const fetchAllXMLZip = async () => {
    const response = await fetch(exports.allXMLZipURL, {
        mode: "cors",
    });
    if (!response.ok)
        throw Error(response.statusText);
    return await response.arrayBuffer();
};
exports.fetchAllXMLZip = fetchAllXMLZip;
const fetchPartialLaw = async (options) => {
    const { lawNum, article, paragraph, appdxTable } = options;
    const elApplData = await (0, exports.fetchElaws)(`${exports.articlesURL};lawNum=${lawNum}${article ? ";article=" + article : ""}${paragraph ? ";paragraph=" + paragraph : ""}${appdxTable ? ";apdxTable=" + appdxTable : ""}`);
    if (!elApplData) {
        throw Error("fetchPartialLaw(): fetchElaws failed");
    }
    const lawContents = elApplData.getElementsByTagName("LawContents").item(0);
    const element = Array.from(lawContents?.childNodes ?? []).find(el => el.nodeType === 1);
    if (!element) {
        throw Error("fetchPartialLaw(): Target element not exist");
    }
    const xml = xmlSerializer.serializeToString(element);
    return xml;
};
exports.fetchPartialLaw = fetchPartialLaw;
//# sourceMappingURL=elawsApi.js.map